import {createAsyncAction} from "typesafe-actions";
import {BonusType} from "../player/types";

type ApplyHintsArgs = {
    readonly id: string;
    readonly hint: BonusType;
}

export const applyHint = createAsyncAction(
    '@hints/APPLY_HINT_REQUEST',
    '@hints/APPLY_HINT_SUCCESS',
    '@hints/APPLY_HINT_FAILURE')<ApplyHintsArgs, ApplyHintsArgs, ApplyHintsArgs>();